import { match, matchPath } from 'react-router'
import { createSelector } from 'reselect'
import {
  CspUserDetailMatchParams,
  cspUserDetailRouteProps,
} from 'src/navigation/routeProps'
import { RootState } from 'src/redux/createRootReducer'
import {
  selectCspUserListModelsFromState,
  selectUserListModelsFromState,
} from 'src/redux/selectors/data/users.selectors'
import { selectLocationFromState } from 'src/redux/selectors/router.selectors'

export const selectPostingAccessCodeFromState = (state: RootState): boolean =>
  state.app.cspUserDetail.postingAccessCode
export const selectHasCreatedAccessCodeFromState = (
  state: RootState,
): boolean => state.app.cspUserDetail.hasCreatedAccessCode

export const selectUserIdFromRoute = createSelector(
  [selectLocationFromState],
  (location) => {
    const mtch = matchPath<CspUserDetailMatchParams>(
      location.pathname,
      cspUserDetailRouteProps,
    ) as match<CspUserDetailMatchParams>
    return mtch.params.id
  },
)

export const selectUser = createSelector(
  [selectUserListModelsFromState, selectUserIdFromRoute],
  (users, userId) => {
    return users[userId] !== undefined ? users[userId] : undefined
  },
)

export const selectCspUser = createSelector(
  [selectCspUserListModelsFromState, selectUserIdFromRoute],
  (users, userId) => {
    return users[userId] !== undefined ? users[userId] : undefined
  },
)
